import React, { Component, createRef } from 'react';
import { ListGroup, OverlayTrigger } from 'react-bootstrap';
import HashLink from 'components/HashLink';
import { language } from 'utils/i18n';
import URL from 'utils/URL';
import './style.scss';

interface IState {
    show: boolean;
}

const langsConfig = [
    {
        id: 'zh_CN',
        name: '中文简体'
    },
    {
        id: 'en_US',
        name: 'English'
    }
];

const langName = langsConfig.find(item => item.id === language)!.name;

class LangSwitch extends Component<{}, IState> {
    readonly state = {
        show: false
    };

    targetRef = createRef<any>();

    onClick = (ev: React.MouseEvent) => {
        ev.preventDefault();

        this.setState({
            show: true
        });
    };

    hide = () =>
        this.setState({
            show: false
        });

    node: any;

    public render() {
        return (
            <OverlayTrigger
                placement="top"
                show={this.state.show}
                overlay={<OverlayContainer target={this.targetRef.current} hide={this.hide} />}>
                <HashLink ref={this.targetRef} onClick={this.onClick}>
                    {langName}
                </HashLink>
            </OverlayTrigger>
        );
    }
}

class OverlayContainer extends Component<
    {
        className?: string;
        style?: any;
        target: HTMLElement | null;
        hide(): void;
    },
    {
        top: number;
        left: number;
    }
> {
    readonly state = {
        top: -1e10,
        left: -1e10
    };

    curNode: any;

    constructor(props) {
        super(props);
        this.curNode = React.createRef();
    }

    public componentDidMount() {
        this.resize();

        window.addEventListener('scroll', this.resize, false);
    }

    public componentWillUnmount() {
        window.removeEventListener('scroll', this.resize, false);
    }

    refSet = ref => {
        this.curNode = ref;
    };

    resize = () => {
        if (this.props.target && this.curNode) {
            const targetRect = this.props.target.getBoundingClientRect();
            const curRect = this.curNode.getBoundingClientRect();

            this.setState({
                top: targetRect.top - targetRect.height - 40,
                left: (window.innerWidth - curRect.width) / 2
            });
        }
    };

    public render() {
        const { className } = this.props;

        return (
            <div
                className={`lang-switch-root ${className}`}
                ref={this.refSet}
                style={{ top: `${this.state.top}px`, left: `${this.state.left}px` }}>
                <ListGroup>
                    {langsConfig.map(item =>
                        item.id === language ? null : (
                            <a
                                key={item.id}
                                href={URL.merge(window.location.href, { query: { lang: item.id } })}
                                className="list-group-item">
                                {item.name}
                            </a>
                        )
                    )}
                </ListGroup>
            </div>
        );
    }
}

export default LangSwitch;
